import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { CartService } from '../../cart/cart.service';

@Component({
  selector: 'nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss']
})
export class NavBarComponent implements OnInit, OnDestroy {
  megaMenuActive = false;

  cartItemCount: number;
  subscription: Subscription;


  constructor(private _cartService: CartService) { }

  ngOnInit() {
    this.subscription = this._cartService.itemsInCart$.subscribe(itemCount => {
      this.cartItemCount = itemCount;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  toggleMegaMenu(isOpen: boolean) {
    this.megaMenuActive = isOpen;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/nav-bar/nav-bar.component.ts